module.exports = __webpack_public_path__ + "images/components/new_arrival_estimate_entries/megaphone_2a39dc9cdd16abfc932cd53b91233d16.png";